import can from 'can';

export default can.Map.extend({
    define: {
        filterType: {
            type: 'string',
            value: null,
        },
        filter: {
            set(cb) {
                if (cb && typeof cb !== 'function') {
                    throw new Error('Search filter must be function');
                }
                return cb;
            },
        },
    },
});
